export function getRandom(digit = 5) {
  return `${Math.random()}`.slice(2, digit + 2);
}
